export default {"src":"__ASTRO_ASSET_IMAGE__hwosS7ZL__","width":128,"height":128,"format":"webp"}